import { render, staticRenderFns } from "./epasCopyReward.vue?vue&type=template&id=6e1fc24a&scoped=true&"
import script from "./epasCopyReward.vue?vue&type=script&lang=js&"
export * from "./epasCopyReward.vue?vue&type=script&lang=js&"
import style0 from "./epasCopyReward.vue?vue&type=style&index=0&id=6e1fc24a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1fc24a",
  null
  
)

export default component.exports